'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProvider = getProvider;
exports.log = log;
exports.getStub = getStub;

var _diffusion = require('./diffusion');

var _diffusion2 = _interopRequireDefault(_diffusion);

var _stub = require('./stub');

var _stub2 = _interopRequireDefault(_stub);

var _cookie = require('../utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stubImplementation = (0, _stub2.default)();
var diffusionImplementation = (0, _diffusion2.default)();
function getImplementation() {
    var diffusionStubEnabled = (0, _cookie2.default)('DiffusionStubEnable') === 'true';
    var apiStubsEnabled = Boolean((0, _cookie2.default)('apiStubs'));

    return diffusionStubEnabled || apiStubsEnabled ? stubImplementation : diffusionImplementation;
}

function getProvider() {
    return getImplementation().provider;
}

function log() {
    var _getImplementation;

    (_getImplementation = getImplementation()).log.apply(_getImplementation, arguments);
}

function getStub() {
    return stubImplementation;
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/index.js
// module id = 661
// module chunks = 1